export const sortBy = (key, reverse, primer = null) => {
  const prime = (value) => (primer ? primer(value[key]) : value[key]);

  const compareFunction = (a, b) => {
    const primeA = prime(a) || '';
    const primeB = prime(b) || '';
    const order = [1, -1][+!!reverse];

    // eslint-disable-next-line no-nested-ternary
    return (primeA < primeB ? -1 : primeA > primeB ? 1 : 0) * order;
  };

  return compareFunction;
};
